/* The phone menu - the button at the top left of the header. Runs for every
   phone visitor, app or not, so it sits before the app-only check below. */
(function () {
  'use strict';
  /* --- Side menu -------------------------------------------------------- */
  /* The hamburger at the top left. Opening it puts away the fan, the bag and
     search first, so no two overlays are ever stacked. */
  var menu = document.getElementById('appmenu');
  var menuBtn = document.querySelector('[data-pwa-menu-open]');
  function setMenu(open) {
    if (!menu) return;
    if (open) {
      /* The app's fan, if it is open, folds away with a click on its toggle. */
      var openFan = document.querySelector('[data-pwa-fan].is-open [data-pwa-fan-toggle]');
      if (openFan) openFan.click();
      var drawerClose = document.querySelector('#cart-drawer:not([hidden]) [data-close-drawer]');
      if (drawerClose) drawerClose.click();
      var cancel = document.getElementById('closesearch');
      var panel = document.getElementById('searchpanel');
      if (cancel && panel && !panel.hidden) cancel.click();
      if (window.msCloseAccount) window.msCloseAccount();
    }
    menu.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (menu && menuBtn) {
    menuBtn.addEventListener('click', function () { setMenu(menu.hidden); });
    menu.addEventListener('click', function (e) {
      /* The veil and the X close it; so does following any link inside. */
      if (e.target.closest('[data-pwa-menu-close]') || e.target.closest('a[href]')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !menu.hidden) setMenu(false); });
    /* Returning with Back from a page the menu led to restores this one from
       the bfcache with the menu still drawn open. */
    window.addEventListener('pageshow', function (e) { if (e.persisted) setMenu(false); });
  }

})();

/* Home-screen app behaviours, ported from the SansMinds app shell.
   Does nothing unless html.pwa-app is set (the head script in theme.liquid).
   theme.js still owns search, the bag drawer, the account menu and the
   appearance toggle - this file only adds what an app has and a website does
   not: a back button, a collapsing title, tabs that remember where you were,
   and the fan. */
(function () {
  'use strict';

  var root = document.documentElement;
  if (!root.classList.contains('pwa-app')) return;

  var nav = document.querySelector('.nav');
  var tabbar = document.querySelector('.tabbar');

  function normalise(path) { return (path || '/').replace(/\/+$/, '') || '/'; }
  var here = normalise(location.pathname);

  /* A tab root is any page a capsule tab points at, plus "/" - the manifest
     starts there, and a launch screen with a back button to nowhere is the
     first thing that breaks the illusion. */
  var isTabRoot = here === '/' || Array.prototype.some.call(
    tabbar ? tabbar.querySelectorAll('.capsule a[href]') : [],
    function (a) {
      try { return normalise(new URL(a.getAttribute('href'), location.origin).pathname) === here; }
      catch (e) { return false; }
    }
  );

  /* --- Back button ------------------------------------------------------ */
  var back = document.querySelector('[data-pwa-back]');
  if (back && !isTabRoot && window.history.length > 1) {
    back.hidden = false;
    root.classList.add('pwa-has-back');
    back.addEventListener('click', function () { window.history.back(); });
  }

  /* --- Bar fill --------------------------------------------------------- */
  /* Transparent at rest, frosted once anything scrolls under it - separate
     from the title, so the back button is readable as soon as it overlaps
     content rather than only when the heading has gone. */
  if (nav) {
    var solid = function () { nav.classList.toggle('is-solid', window.scrollY > 8); };
    solid();
    window.addEventListener('scroll', solid, { passive: true });

    /* iOS draws the transparent bar during the app's launch zoom and keeps
       that small, soft copy until something repaints it - which is why the
       logo sharpened the moment you scrolled (the fill change is a repaint).
       Nudge a repaint once the launch has settled, and again on returning
       to the app (Rich, 09-29). */
    var repaint = function () {
      nav.classList.add('is-repaint');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { nav.classList.remove('is-repaint'); });
      });
    };
    [60, 400, 900].forEach(function (ms) { setTimeout(repaint, ms); });
    window.addEventListener('pageshow', function () { setTimeout(repaint, 60); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') setTimeout(repaint, 60);
    });
  }

  /* --- Account sheet: swipe down to close ------------------------------ */
  /* The grabber promised it; nothing answered. A drag that starts on the
     sheet while its list is at the top follows the finger, and past 90px
     (or a quick flick) the sheet goes; otherwise it springs back. */
  var sheet = document.getElementById('acct');
  if (sheet) {
    var startY = 0, lastY = 0, lastT = 0, dragging = false, velocity = 0;
    sheet.addEventListener('touchstart', function (e) {
      /* A sheet only on phones; an installed iPad keeps the web's dropdown. */
      if (!window.matchMedia('(max-width: 767px)').matches) return;
      if (sheet.hidden || sheet.scrollTop > 0 || e.touches.length !== 1) return;
      if (e.target.closest && e.target.closest('select, input, textarea')) return;
      startY = lastY = e.touches[0].clientY; lastT = Date.now();
      dragging = true; velocity = 0;
    }, { passive: true });
    sheet.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      var y = e.touches[0].clientY, dy = y - startY, now = Date.now();
      if (dy < 0) { sheet.style.transform = ''; return; }   /* upward: let it scroll */
      velocity = (y - lastY) / Math.max(1, now - lastT); lastY = y; lastT = now;
      if (e.cancelable) e.preventDefault();                  /* no page bounce under it */
      sheet.style.transition = 'none';
      sheet.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    var finish = function () {
      if (!dragging) return;
      dragging = false;
      var dy = lastY - startY;
      sheet.style.transition = 'transform .22s cubic-bezier(.2, .8, .2, 1)';
      if (dy > 90 || velocity > 0.5) {
        sheet.style.transform = 'translateY(100%)';
        setTimeout(function () {
          if (window.msCloseAccount) window.msCloseAccount(); else sheet.hidden = true;
          sheet.style.transition = ''; sheet.style.transform = '';
        }, 220);
      } else {
        sheet.style.transform = '';
        setTimeout(function () { sheet.style.transition = ''; }, 220);
      }
    };
    sheet.addEventListener('touchend', finish);
    sheet.addEventListener('touchcancel', finish);

    /* While the sheet is up the page stays put (Rich, 09-29: the page
       scrolled behind it). A drag outside the sheet does nothing; inside, it
       scrolls the sheet's own list, and the CSS stops that chaining out. */
    document.addEventListener('touchmove', function (e) {
      if (sheet.hidden || !window.matchMedia('(max-width: 767px)').matches) return;
      if (!sheet.contains(e.target) && e.cancelable) e.preventDefault();
    }, { passive: false });
  }

  /* --- Collapsing title ------------------------------------------------- */
  /* Apple's large-title collapse: the compact title appears once the page's
     own heading has scrolled under the bar. */
  var titleEl = document.querySelector('[data-pwa-title]');
  /* Not on the home screen: its h1 is an SEO line for search engines, and the
     wordmark is the right title there anyway. */
  if (nav && titleEl && here !== '/') {
    var h1 = document.querySelector('main [data-pwa-title-source]') || document.querySelector('main h1');
    var label = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!label) {
      var lit = tabbar && tabbar.querySelector('.capsule a[aria-current="page"]');
      label = lit ? lit.textContent.trim() : document.title.split(/\s[–-]\s/)[0].trim();
    }
    titleEl.textContent = label;
    titleEl.hidden = false;

    if (h1 && 'IntersectionObserver' in window) {
      var barH = nav.offsetHeight || 48;
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        /* Only "titled" once the heading has gone UP past the bar, not while
           it is still below the fold on a long product page. */
        nav.classList.toggle('is-titled', !e.isIntersecting && e.boundingClientRect.top < barH);
      }, { rootMargin: '-' + barH + 'px 0px 0px 0px', threshold: 0 }).observe(h1);
    } else {
      var onScroll = function () { nav.classList.toggle('is-titled', window.scrollY > 24); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* --- Per-tab scroll memory ------------------------------------------- */
  /* Each tab stays parked where it was left, for the session. */
  var KEY = 'pwa:scroll:';
  function saveScroll() {
    if (!isTabRoot) return;
    try { sessionStorage.setItem(KEY + here, String(window.scrollY)); } catch (e) {}
  }
  window.addEventListener('pagehide', saveScroll);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') saveScroll();
  });
  if (isTabRoot) {
    var navEntry = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    if (!(navEntry && navEntry.type === 'reload')) {
      try {
        var y = Number(sessionStorage.getItem(KEY + here));
        if (y > 0) requestAnimationFrame(function () { requestAnimationFrame(function () { window.scrollTo(0, y); }); });
      } catch (e) {}
    }
  }

  /* --- Status bar colour ------------------------------------------------ */
  /* The two theme-color metas follow the phone. When the shopper forces a
     mode with the appearance toggle, a media-less one goes in front of them,
     or the status bar stays white over a black app. Watching data-theme
     catches the toggle wherever it is pressed. */
  function syncThemeColor() {
    var mode = root.getAttribute('data-theme');
    var forced = document.head.querySelector('meta[name="theme-color"][data-pwa-forced]');
    if (mode !== 'light' && mode !== 'dark') {
      if (forced) forced.parentNode.removeChild(forced);
      return;
    }
    if (!forced) {
      forced = document.createElement('meta');
      forced.name = 'theme-color';
      forced.setAttribute('data-pwa-forced', '');
      document.head.insertBefore(forced, document.head.querySelector('meta[name="theme-color"]'));
    }
    forced.content = getComputedStyle(document.body).backgroundColor || (mode === 'dark' ? '#000000' : '#ffffff');
  }
  syncThemeColor();
  if (window.MutationObserver) {
    new MutationObserver(syncThemeColor).observe(root, { attributes: true, attributeFilter: ['data-theme'] });
  }
  /* A back step restores the page from the bfcache as it was painted, so a
     mode changed on the next page would not show here. Re-read it. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var pref = null;
    try { pref = localStorage.getItem('magicstore:theme'); } catch (err) {}
    if (pref === 'light' || pref === 'dark') root.setAttribute('data-theme', pref);
    else root.removeAttribute('data-theme');
    document.querySelectorAll('[data-theme-toggle]').forEach(function (b) {
      b.dataset.mode = pref === 'light' || pref === 'dark' ? pref : 'system';
    });
  });

  /* --- The fan ---------------------------------------------------------- */
  var fan = document.querySelector('[data-pwa-fan]');
  if (!fan) return;
  var toggle = fan.querySelector('[data-pwa-fan-toggle]');
  var scrim = null;

  function isOpen() { return fan.classList.contains('is-open'); }

  function setFan(open) {
    fan.classList.toggle('is-open', open);
    if (tabbar) tabbar.classList.toggle('is-fanned', open);
    root.classList.toggle('pwa-fan-open', open);
    if (toggle) {
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close' : 'More');
    }
    if (open && !scrim) {
      scrim = document.createElement('div');
      scrim.className = 'appfan-scrim';
      /* Beside the tab bar, in the same stacking context - see pwa-app.css. */
      if (tabbar && tabbar.parentNode) tabbar.parentNode.insertBefore(scrim, tabbar);
      else document.body.appendChild(scrim);
      requestAnimationFrame(function () { if (scrim) scrim.classList.add('is-open'); });
    } else if (!open && scrim) {
      var dying = scrim;
      scrim = null;
      dying.classList.remove('is-open');
      setTimeout(function () { if (dying.parentNode) dying.parentNode.removeChild(dying); }, 240);
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-pwa-fan-toggle]')) { e.preventDefault(); setFan(!isOpen()); return; }

    /* Account: press the web avatar button for them, after this click has
       finished travelling - theme.js closes the menu on any outside click,
       and this one would otherwise count. */
    if (e.target.closest('[data-pwa-account]')) {
      setFan(false);
      setTimeout(function () {
        var btn = document.getElementById('openacct');
        if (btn) btn.click(); else window.location.href = '/account';
      }, 0);
      return;
    }
    if (isOpen() && e.target.closest('[data-pwa-fan-close]')) { setFan(false); return; }
    if (isOpen() && !e.target.closest('[data-pwa-fan]')) setFan(false);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) setFan(false); });
})();
